import React from "react";
import { ISVGProps } from "types";

export default function EnteIcon(props: ISVGProps) {
    return (
        <svg
            width="290"
            height="277"
            viewBox="0 0 290 277"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g filter="url(#filter0_dddd_25635_168602)">
                <g clip-path="url(#clip0_25635_168602)">
                    <rect
                        x="5"
                        y="0.999512"
                        width="150"
                        height="150"
                        rx="34.2773"
                        fill="url(#paint0_linear_25635_168602)"
                    />
                    <g opacity="0.8" filter="url(#filter1_dii_25635_168602)">
                        <path
                            d="M80.0533 24.73L38.1055 43.3734V71.3386C38.1055 97.2065 56.0032 121.396 80.0533 127.269C104.103 121.396 122.001 97.2065 122.001 71.3386V43.3734L80.0533 24.73ZM80.0533 52.6952C86.5785 52.6952 93.1037 57.8221 93.1037 64.3473V71.3386C95.9002 71.3386 98.6967 74.1352 98.6967 77.3978V93.7108C98.6967 96.5073 95.9002 99.3038 92.6376 99.3038H67.0028C64.2063 99.3038 61.4098 96.5073 61.4098 93.2447V76.9317C61.4098 74.1352 64.2063 71.3386 67.0028 71.3386V64.3473C67.0028 57.8221 73.5281 52.6952 80.0533 52.6952ZM80.0533 58.2882C76.3246 58.2882 73.062 60.6187 73.062 64.3473V71.3386H87.0446V64.3473C87.0446 60.6187 83.782 58.2882 80.0533 58.2882Z"
                            fill="white"
                        />
                    </g>
                    <g opacity="0.8" filter="url(#filter2_dii_25635_168602)">
                        <path
                            d="M80.0533 24.73L38.1055 43.3734V71.3386C38.1055 97.2065 56.0032 121.396 80.0533 127.269C104.103 121.396 122.001 97.2065 122.001 71.3386V43.3734L80.0533 24.73ZM80.0533 52.6952C86.5785 52.6952 93.1037 57.8221 93.1037 64.3473V71.3386C95.9002 71.3386 98.6967 74.1352 98.6967 77.3978V93.7108C98.6967 96.5073 95.9002 99.3038 92.6376 99.3038H67.0028C64.2063 99.3038 61.4098 96.5073 61.4098 93.2447V76.9317C61.4098 74.1352 64.2063 71.3386 67.0028 71.3386V64.3473C67.0028 57.8221 73.5281 52.6952 80.0533 52.6952ZM80.0533 58.2882C76.3246 58.2882 73.062 60.6187 73.062 64.3473V71.3386H87.0446V64.3473C87.0446 60.6187 83.782 58.2882 80.0533 58.2882Z"
                            fill="white"
                        />
                    </g>
                    <g opacity="0.8" filter="url(#filter3_ii_25635_168602)">
                        <path
                            d="M80.0533 24.73L38.1055 43.3734V71.3386C38.1055 97.2065 56.0032 121.396 80.0533 127.269C104.103 121.396 122.001 97.2065 122.001 71.3386V43.3734L80.0533 24.73ZM80.0533 52.6952C86.5785 52.6952 93.1037 57.8221 93.1037 64.3473V71.3386C95.9002 71.3386 98.6967 74.1352 98.6967 77.3978V93.7108C98.6967 96.5073 95.9002 99.3038 92.6376 99.3038H67.0028C64.2063 99.3038 61.4098 96.5073 61.4098 93.2447V76.9317C61.4098 74.1352 64.2063 71.3386 67.0028 71.3386V64.3473C67.0028 57.8221 73.5281 52.6952 80.0533 52.6952ZM80.0533 58.2882C76.3246 58.2882 73.062 60.6187 73.062 64.3473V71.3386H87.0446V64.3473C87.0446 60.6187 83.782 58.2882 80.0533 58.2882Z"
                            fill="white"
                        />
                    </g>
                </g>
                <rect
                    x="5.09223"
                    y="1.09174"
                    width="149.816"
                    height="149.816"
                    rx="34.1851"
                    stroke="url(#paint1_linear_25635_168602)"
                    stroke-width="0.18445"
                />
            </g>
            <defs>
                <filter
                    id="filter0_dddd_25635_168602"
                    x="0"
                    y="-0.000488281"
                    width="160"
                    height="168"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_25635_168602"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="3" />
                    <feGaussianBlur stdDeviation="1.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_25635_168602"
                        result="effect2_dropShadow_25635_168602"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="7" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect2_dropShadow_25635_168602"
                        result="effect3_dropShadow_25635_168602"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="12" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect3_dropShadow_25635_168602"
                        result="effect4_dropShadow_25635_168602"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect4_dropShadow_25635_168602"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_dii_25635_168602"
                    x="11.8281"
                    y="14.219"
                    width="136.45"
                    height="155.094"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="15.7664" />
                    <feGaussianBlur stdDeviation="13.1387" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_25635_168602"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_25635_168602"
                        result="shape"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.62774" />
                    <feGaussianBlur stdDeviation="1.31387" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect2_innerShadow_25635_168602"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="-1.31387" />
                    <feGaussianBlur stdDeviation="0.656935" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect2_innerShadow_25635_168602"
                        result="effect3_innerShadow_25635_168602"
                    />
                </filter>
                <filter
                    id="filter2_dii_25635_168602"
                    x="11.8281"
                    y="14.219"
                    width="136.45"
                    height="155.094"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="15.7664" />
                    <feGaussianBlur stdDeviation="13.1387" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_25635_168602"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_25635_168602"
                        result="shape"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.62774" />
                    <feGaussianBlur stdDeviation="1.31387" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect2_innerShadow_25635_168602"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="-1.31387" />
                    <feGaussianBlur stdDeviation="0.656935" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect2_innerShadow_25635_168602"
                        result="effect3_innerShadow_25635_168602"
                    />
                </filter>
                <filter
                    id="filter3_ii_25635_168602"
                    x="38.1055"
                    y="23.4161"
                    width="83.8955"
                    height="106.481"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2.62774" />
                    <feGaussianBlur stdDeviation="1.31387" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_25635_168602"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="-1.31387" />
                    <feGaussianBlur stdDeviation="0.656935" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_innerShadow_25635_168602"
                        result="effect2_innerShadow_25635_168602"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_25635_168602"
                    x1="19.1357"
                    y1="11.3999"
                    x2="149.287"
                    y2="144.188"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#C373F2" />
                    <stop offset="1" stop-color="#9610D6" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_25635_168602"
                    x1="5"
                    y1="0.999512"
                    x2="164.091"
                    y2="162.363"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#B37FEB" />
                    <stop offset="1" stop-color="#22075E" />
                </linearGradient>
                <clipPath id="clip0_25635_168602">
                    <rect
                        x="5"
                        y="0.999512"
                        width="150"
                        height="150"
                        rx="34.2773"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
